import { createAction } from "redux-actions";

export const update = createAction("ROUTE_UPDATE", state => state);
